import { RootStateOrAny, useSelector } from 'react-redux';
import { selectQuestionAnswers } from '../../../../../../../../../redux/questionnaire/selectors';

export const useCurrentParentQuestionAnswers = (parentQuestionId?: string | null) => {
  const answers = useSelector((state: RootStateOrAny) => selectQuestionAnswers(state, parentQuestionId || null));

  return answers;
};
